namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItem4Form {
        PmGroupId: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmExtCode: Serenity.StringEditor;
        PmDesc: Serenity.StringEditor;
        PmOrder: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        ItemType: Serenity.EnumEditor;
        FreeLpFg: Serenity.RadioButtonEditor;
        Price1: Serenity.DecimalEditor;
        Price2: Serenity.DecimalEditor;
        Price3: Serenity.DecimalEditor;
        Price4: Serenity.DecimalEditor;
        AssortFg: Serenity.RadioButtonEditor;
        ListFg: Serenity.RadioButtonEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItem4Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItem4';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItem4Form.init)  {
                PsAdvPromoItem4Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.EnumEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItem4Form, [
                    'PmGroupId', w0,
                    'PmId', w0,
                    'PmType', w1,
                    'PmExtCode', w0,
                    'PmDesc', w0,
                    'PmOrder', w1,
                    'LineItemNo', w1,
                    'ItemType', w2,
                    'FreeLpFg', w3,
                    'Price1', w4,
                    'Price2', w4,
                    'Price3', w4,
                    'Price4', w4,
                    'AssortFg', w3,
                    'ListFg', w3,
                    'PluCode', w5,
                    'StyleCode', w5,
                    'BrandCode', w5,
                    'CatCode', w5,
                    'SubCat1Code', w5,
                    'SubCat2Code', w5,
                    'SupplCode', w5
                ]);
            }
        }
    }
}
